/** @jsxImportSource @emotion/react */

import { ComponentType, ElementType, forwardRef } from 'react';

import { parseRenderSettings } from '../services/parseRenderSettings';

import { Storyblok } from '../storyblok';

type WrappedProps<T = Record<string, unknown>> = {
    renderAs?: ComponentType<T> | ElementType;
    renderSettings?: Storyblok.Component.RenderSettings;
} & T;

export const Wrapped = forwardRef(
    ({ renderAs: Component, renderSettings, ...props }: WrappedProps, ref) => {
        if (!Component) return null;

        const { storyblokCustomStyles, storyblokCustomProps } =
            parseRenderSettings(renderSettings);

        return (
            <Component
                ref={ref}
                css={storyblokCustomStyles}
                {...props}
                {...storyblokCustomProps}
            />
        );
    },
);
